import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-custom-overlay",
  template: `
    <div class="custom-overlay-backdrop" (click)="onBackdropClick()">
      <div class="custom-overlay-content" (click)="$event.stopPropagation()">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  styles: [
    `
      .custom-overlay-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        padding: 20px;
      }

      .custom-overlay-content {
        background: white;
        border-radius: 12px;
        max-width: 500px;
        width: 100%;
        max-height: 90vh;
        overflow-y: auto;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        animation: slideUp 0.3s ease-out;
      }

      @keyframes slideUp {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }

      /* iOS safe area support */
      @supports (padding: max(0px)) {
        .custom-overlay-content {
          padding-bottom: max(0px, env(safe-area-inset-bottom));
        }
      }
    `,
  ],
})
export class CustomOverlayComponent {
  @Input() closeOnBackdropClick = true;
  @Output() backdropClick = new EventEmitter<void>();

  onBackdropClick() {
    if (this.closeOnBackdropClick) {
      this.backdropClick.emit();
    }
  }
}
